import React from 'react';
import { BarChart2Icon, BookOpenIcon, CodeIcon, FileTextIcon, HomeIcon, LayersIcon, SearchIcon, Settings2Icon, UsersIcon } from 'lucide-react';
export function Sidebar() {
  return <div className="w-56 bg-white border-r h-full overflow-y-auto shadow-sm" data-id="element-530">
      <div className="p-4" data-id="element-531">
        <div className="flex items-center mb-8" data-id="element-532">
          <div className="w-8 h-8 rounded-md bg-gradient-to-r from-indigo-600 to-purple-600 text-white flex items-center justify-center mr-2" data-id="element-533">
            <span className="font-bold" data-id="element-534">P</span>
          </div>
          <span className="font-bold text-lg text-gray-900" data-id="element-535">Polify</span>
        </div>
        <nav data-id="element-536">
          <div className="mb-2 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-537">
            Main
          </div>
          <ul className="space-y-1 mb-6" data-id="element-538">
            <li data-id="element-539">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-540">
                <HomeIcon size={18} className="mr-3 text-gray-500" data-id="element-541" />
                Dashboard
              </a>
            </li>
            <li data-id="element-542">
              <a href="#" className="flex items-center text-sm text-indigo-700 bg-indigo-50 py-2 px-3 rounded-md" data-id="element-543">
                <SearchIcon size={18} className="mr-3 text-indigo-700" data-id="element-544" />
                Search
              </a>
            </li>
            <li data-id="element-545">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-546">
                <FileTextIcon size={18} className="mr-3 text-gray-500" data-id="element-547" />
                Reports
              </a>
            </li>
            <li data-id="element-548">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-549">
                <BarChart2Icon size={18} className="mr-3 text-gray-500" data-id="element-550" />
                Analytics
              </a>
            </li>
          </ul>
          <div className="mb-2 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-551">
            Resources
          </div>
          <ul className="space-y-1 mb-6" data-id="element-552">
            <li data-id="element-553">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-554">
                <UsersIcon size={18} className="mr-3 text-gray-500" data-id="element-555" />
                Payers
              </a>
            </li>
            <li data-id="element-556">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-557">
                <CodeIcon size={18} className="mr-3 text-gray-500" data-id="element-558" />
                Codes
              </a>
            </li>
            <li data-id="element-559">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-560">
                <LayersIcon size={18} className="mr-3 text-gray-500" data-id="element-561" />
                Categories
              </a>
            </li>
            <li data-id="element-562">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-563">
                <BookOpenIcon size={18} className="mr-3 text-gray-500" data-id="element-564" />
                Knowledge Base
              </a>
            </li>
          </ul>
          <div className="mb-2 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-565">
            Settings
          </div>
          <ul className="space-y-1" data-id="element-566">
            <li data-id="element-567">
              <a href="#" className="flex items-center text-sm text-gray-600 hover:text-gray-900 py-2 px-3 rounded-md hover:bg-gray-50" data-id="element-568">
                <Settings2Icon size={18} className="mr-3 text-gray-500" data-id="element-569" />
                Preferences
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="px-4 py-4 mt-8 border-t" data-id="element-570">
        <div className="flex items-center" data-id="element-571">
          <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center mr-2" data-id="element-572">
            <span className="font-medium" data-id="element-573">WD</span>
          </div>
          <div data-id="element-574">
            <div className="text-sm font-medium" data-id="element-575">Weston Dean</div>
            <div className="text-xs text-indigo-600" data-id="element-576">Professional</div>
          </div>
        </div>
      </div>
    </div>;
}